var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCancerCharities = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Medical-Ribbon-Cancer--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Medical Ribbon Cancer Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.39 20.47a28.48 28.48 0 0 1 -3.2 -2.56 0.53 0.53 0 0 1 0 -0.72c2.54 -3.06 4.16 -5.66 4.16 -9C19.3 3.69 16 0 12 0S4.7 3.69 4.7 8.24c0 3.44 1.79 6.09 4.16 9a0.53 0.53 0 0 1 0 0.72 28.48 28.48 0 0 1 -3.2 2.56 0.52 0.52 0 0 0 -0.14 0.72l1.7 2.58a0.57 0.57 0 0 0 0.28 0.18 0.48 0.48 0 0 0 0.4 -0.09 32 32 0 0 0 3.75 -3 0.5 0.5 0 0 1 0.7 0 32 32 0 0 0 3.75 3 0.48 0.48 0 0 0 0.4 0.09 0.57 0.57 0 0 0 0.33 -0.22l1.7 -2.58a0.52 0.52 0 0 0 -0.14 -0.73ZM8.87 8.82c-0.32 -2.58 1.4 -4.7 3.13 -4.7s3.45 2.12 3.13 4.7a11.7 11.7 0 0 1 -2.72 5.27 0.54 0.54 0 0 1 -0.82 0 11.7 11.7 0 0 1 -2.72 -5.27Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCancerCharities);
export default ForwardRef;